import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCastoramaComponent } from './simple-icons-castorama.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCastoramaComponent ],
    exports:      [ SimpleIconsCastoramaComponent ],
    bootstrap:    []
})
export class SimpleIconsCastoramaModule {}
